export default __webpack_public_path__ + "static/media/Office.6f98b54e.jpg";